export default function (event: KeyboardEvent):void {
  const e = event || window.event as KeyboardEvent
  const charCode = e.which || e.keyCode
  if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
    e.preventDefault()
  }
}
